import React, { Fragment, useEffect, useState } from 'react'
import { Row, Col, Button, Divider, Spin } from 'antd'
import '../styles/Home.css'
import UserInput from './UserInput'
import UserOutput from './UserOutput'
import { logEvent } from 'firebase/analytics'
import { analytics } from '../firebaseInit'
import { InsurancePlan } from '../data/plan'

const defaultAge = 25

export const styleButtonActive = {
  border: '1px solid #4096ff',
}

export default function Home() {
  const [gender, setGender] = useState('M')
  const [age, setAge] = useState(defaultAge)
  const [isShowResult, setIsShowResult] = useState<boolean>(false)
  const [selectedPlan, setSelectedPlan] = useState<InsurancePlan|null>(null)
  const [spinning, setSpinning] = useState(false)

  const onCountClick = () => {
    logEvent(analytics, 'click_count', {
      insured_age: age,
      insured_gender: gender,
    })
    setIsShowResult(true)
    setSpinning(true)
  }
  const onPlanSelected = (plan: InsurancePlan) => {
    logEvent(analytics, 'click_plan', {
      plan_id: plan.planId,
    })
    setSelectedPlan(plan)
  }

  const getGenderString = (gender: string) => {
    return gender === 'M' ? 'Pria' : 'Wanita'
  }

  const contactWA = () => {
    logEvent(analytics, 'click_whatsapp')
    let message = `Hai agen asuransi Deva,%0aSaya tertarik dengan Asuransi Kesehatan plan ${selectedPlan!.name.toUpperCase()}%0aNama:%0aPria/Wanita: ${getGenderString(gender)}%0aTgl Lahir:%0aUmur: ${age} tahun%0aRiwayat Penyakit:%0aDomisili:%0aTau Deva dari:`
    message = message.replace(' ', '%20')
    const url = `https://wa.me/+62881082729578?text=${message}`
    window.open(url, '_blank')
  }

  useEffect(() => {
    setIsShowResult(false)
  }, [age, gender])

  return (
    <Fragment>
      <Row justify="center">
        <Col xl={10} lg={10} md={20} sm={20} xs={24}>
          <h2 className="center">Cek Harga Premi Asuransi MSIG</h2>
        </Col>
      </Row>
      <UserInput
        gender={gender}
        age={age}
        setGender={setGender}
        setAge={setAge}
        isShowResult={isShowResult}
        onCountClick={onCountClick}
      />
      <Divider className="divider" />
      <Spin spinning={spinning}>
        {isShowResult && (
          <UserOutput
            gender={gender}
            age={age}
            selectedPlan={selectedPlan}
            onPlanSelected={onPlanSelected}
            setSpinning={setSpinning}
          />
        )}

        {isShowResult && (
          <Row justify="center">
            <Col xl={10} lg={10} md={20} sm={20} xs={24} className="center">
              <Button id="buttonCount" onClick={contactWA}>
                Ambil premi!
              </Button>
            </Col>
          </Row>
        )}
      </Spin>
    </Fragment>
  )
}
